<div class="startAQuote" [ngClass]="{ 'shasta': authStore.isAdmin() }">
  @if (title()) {
    <div class="w-full flex title-wrapper">
      <h1 class="app">{{ title() }}</h1>
    </div>
  }

  @for (programTile of programTiles(); track programTile) {
    <div class="w-full flex">
      <h3 class="app my-[20px]">{{ programTile.sectionHeader }}</h3>
    </div>

    <div class="w-full flex flex-col lg:flex-row gap-4 lg:gap-[2.5rem]">
      @for (tile of programTile.programTiles; track tile) {
        <div class="w-full lg:w-1/2">
          <div class="program-tile">
            <div class="logo">
              <img src="{{ tile.imageUrl }}" alt="{{ programTile.heading || 'Program Tile' }}" />
            </div>
            <h3 class="app mt-3">{{ tile.heading }}</h3>
            <ul>
              @for(item of getListItems(tile.subHeading); track item ) {
                <li>
                  {{ item }}
                </li>
              }
            </ul>

            @if (tile.showButton) {
              <div class="py-5">
                <lib-button [cssType]="'btn-secondary'" [buttonType]="'button'" [text]="'Quote Now'" [size]="'small'"  (click)="nextStep(tile)"></lib-button>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
</div>